import {Component, OnDestroy, OnInit} from '@angular/core';
import {faSave, faTrash} from '@fortawesome/free-solid-svg-icons';
import {EditService} from '../shared/services/editService/edit.service';
import {ActivatedRoute, Router} from '@angular/router';
import {RacesService} from '../shared/services/databaseServices/races/races.service';
import {FormBuilder, Validators} from '@angular/forms';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import * as _moment from 'moment';
import {SportTypesService} from '../shared/services/databaseServices/sportTypes/sport-types.service';
import {SportType} from '../shared/classes/SportType';
import {Category} from '../shared/classes/Category';
import {Race} from '../shared/classes/Race';
import {Track} from '../shared/classes/Track';
import {DatePipe} from '@angular/common';


const moment = _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD.MM.YYYY',
  },
  display: {
    dateInput: 'DD.MM.YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};


@Component({
  selector: 'app-race-detail',
  templateUrl: './race-detail.component.html',
  styleUrls: ['./race-detail.component.css'],
  providers: [

    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    DatePipe
  ],
})
export class RaceDetailComponent implements OnInit, OnDestroy {

  private static NEW_ID = 'new';

  copyInterval = undefined;

  faSave = faSave;
  faTrash = faTrash;

  id = undefined;
  isNew = false;
  data = [];
  sportTypes: SportType[] = [];

  raceId;

  race: Race;
  catName = undefined;
  edit = false;
  trackName = undefined;
  editedTrack = false;

  displayedColumns: string[] = ['startTime', 'track', 'trackShort'];

  header = [
    {
      defName: 'startTime',
      translation: 'raceDetailPage.form.tab.startTime',
      elem: 'startTime'
    },
    {
      defName: 'track',
      translation: 'raceDetailPage.form.tab.track',
      elem: 'track'
    },
    {
      defName: 'trackShort',
      translation: 'raceDetailPage.form.tab.trackShort',
      elem: 'trackShort'
    }
  ];

  displayedColumnsCat: string[] = ['name', 'ageFrom', 'ageTo'];

  headerCat = [
    {
      defName: 'name',
      translation: 'settingPage.sportType.nameCat',
      elem: 'name'
    },
    {
      defName: 'ageFrom',
      translation: 'settingPage.sportType.ageFrom',
      elem: 'ageFrom'
    },
    {
      defName: 'ageTo',
      translation: 'settingPage.sportType.ageTo',
      elem: 'ageTo'
    }
  ];

  public tabs = [];

  constructor(private activatedRoute: ActivatedRoute,
              private router: Router,
              private racesService: RacesService,
              private editService: EditService,
              private formBuilder: FormBuilder,
              private sportTypesService: SportTypesService,
              private datePipe: DatePipe) { }

  ngOnInit() {
    this.id = this.activatedRoute.snapshot.firstChild.paramMap.get('id');
    this.isNew = this.id === RaceDetailComponent.NEW_ID;
    this.setTabs(this.id);
    this.raceId = this.isNew ? undefined : this.id;
    this.racesService.raceId = this.id;
  }

  setTabs(id) {
    this.tabs = [
      {
        title: 'racesPage.tabs.main',
        destination: 'main',
        link: '/admin/races/info/' + id
      },
      {
        title: 'racesPage.tabs.startFee',
        destination: 'startFee',
        link: '/admin/races/startFee/' + id
      },
      {
        title: 'racesPage.tabs.racers',
        destination: 'allRacers',
        link: '/admin/races/allRacers/' + id
      },
      {
        title: 'racesPage.tabs.startNumber',
        destination: 'startNumber',
        link: '/admin/races/startNumber/' + id
      },
      {
        title: 'racesPage.tabs.fio',
        destination: 'raceFio',
        link: '/admin/races/raceFio/' + id
      },
      {
        title: 'racesPage.tabs.email',
        destination: 'mailSetting',
        link: '/admin/races/mailSetting/' + id
      },
      {
        title: 'racesPage.tabs.voucher',
        destination: 'voucher',
        link: '/admin/races/voucher/' + id
      }
    ];
  }

  ngOnDestroy(): void {
    clearInterval(this.copyInterval);
  }

  isEdit() {
    return this.editService.editable;
  }
}
